export default __webpack_public_path__ + "static/media/banner-topo-solucoes.a46e9742.png";